<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Termin</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.lessonForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="lessonForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item
        lines="full"
        button
        [disabled]="lesson()?.student"
        (click)="selectStudent()"
        detail="true"
      >
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="person-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-label
          >{{
            lessonForm.value.student_id.forename || "Fahrschüler auswählen"
          }}
          {{ lessonForm.value.student_id.surname }}</ion-label
        >
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="pricetag-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-select
          label="Typ"
          value="Fahrstunde"
          formControlName="type"
          okText="Festlegen"
          cancelText="Abbrechen"
        >
          <ion-select-option value="Fahrstunde">Fahrstunde</ion-select-option>
          <ion-select-option value="Probeprüfung"
            >Probeprüfung</ion-select-option
          >
          <ion-select-option value="Prüfung">Prüfung</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="pricetag-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-select
          label="Lektion"
          formControlName="service_id"
          okText="Festlegen"
          cancelText="Abbrechen"
          (ionChange)="updateToService()"
        >
          @for (service of filteredServices(); track service.service_id) {
            <ion-select-option [value]="service.service_id">
              {{ service.name }} ({{ service.category }})
            </ion-select-option>
          }
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="time-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="Startzeit"
          formControlName="start_time"
          placeholder="Startzeit"
          type="datetime-local"
          (input)="updateFormValues()"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-note slot="start">
          <ion-icon class="-mt-1 text-lg"></ion-icon>
        </ion-note>
        <app-counter-input
          label="Lektionen"
          formControlName="lessons"
          placeholder="Lektionen"
          type="number"
          min="0"
          max="10"
          step="1"
          (input)="updateFormValues()"
        ></app-counter-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon class="-mt-1 text-lg"></ion-icon>
        </ion-note>
        <ion-input
          label="Endzeit"
          formControlName="end_time"
          placeholder="Endzeit"
          type="datetime-local"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="location-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="location"
          placeholder="Treffpunkt"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full" id="open-toast">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="CHF"
          formControlName="prize"
          placeholder="Preis"
          type="number"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="document-text-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          aria-label="Notizen"
          formControlName="notes"
          placeholder="Notizen"
          type="text"
        ></ion-input>
      </ion-item>
    </ion-list>
    @if (lessonForm.value.student_id.mail_student ||
    lessonForm.value.student_id.mobile_no) {
    <ion-list class="mt-5 mb-5">
      @if (lessonForm.value.student_id.mail_student) {
      <ion-item lines="none">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="notifications-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-toggle formControlName="sendReminder"
          >Terminbestätigung senden (E-Mail)</ion-toggle
        >
      </ion-item>
      } @if (lessonForm.value.student_id.mobile_no) {
      <ion-item lines="none" (click)="!(customerEntitlementsSignal()?.includes(Plans.premium) || customerEntitlementsSignal()?.includes(Plans.premium_promo)) ? showPremiumFeatureMessage() : null">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="call-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-toggle formControlName="sms_reminder"
          >Terminerinnerung senden (SMS)</ion-toggle
        >
      </ion-item>
      }
    </ion-list>
    }
  </form>
</ion-content>
